function getGridData(elementSelctor) {
  if ($(elementSelctor).length > 0) {
    var scope = angular.element(elementSelctor).scope();
    if (scope) {
      return scope.filterdData;
    }
  }
  return [];
}
global.getGridData = getGridData;
